import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";

export const Acciones = () => {
	return(
		<Content>
			<H1>Acciones</H1>
			<P>
				Las acciones son gestiones de carácter general que puedes hacer sobre tu cuenta o tu nube mientras tengas los permisos correctos.
			</P>
		</Content>
	)
}

export const CloudOnOff = (props)=>{
    return (
	<Content>
		<H1> Conectar y Desconectar una Nube </H1>
		<P>
			En tu dashboard tienes la funcionalidad de poder desconectar y conectar una nube cuando asi lo desees. A continuación aprenderás a realizar esta gestión sin ninguna dificultad.
		</P>

		<h2> Desconectar una Nube </h2>
		<P>
			Normalmente cuando das de alta una nube esta se encontrara conectada y esto lo puedes verificar en la barra superior del dashboard donde puedes visualizar y seleccionar la nube que querés gestionar, al lado del nombre de está podrás encontrar un icono de un enchufe verde que te indicará que tu nube esta conectada.
		</P>
		<P>
			<img src="/img/OnOffCloud/StateOn.PNG" alt="Estado Conectado"/>
		</P>
		<P>
			Si tu deseo es desconectar la nube solo tienes que hacer clic en el icono de configuración que se encuentra al lado del panel de selección de la nube.
		</P>
		<P>
			<img src="/img/OnOffCloud/StateOn_Focus.png" alt="Estado Conectado Enfocado"/>
		</P>
		<P>
			Al hacer clic se te desplegara un menu donde encontraras la información de conexión de la nube y para desconectarla solo debes dar clic sobre el switch y este cambiara su lugar y procederá a desconectar la nube.
		</P>
		<P>
			<img src="/img/OnOffCloud/MenuOn_Focus.png" alt="Menu Conectado"/>
		</P>
		<P>
			Como ultimo paso aparecerá una ventana de confirmación donde deberás dar clic en Aceptar si deseas desconectar la nube o Cancelar si querés desistir de esta acción.
		</P>
		<P>
			<img src="/img/OnOffCloud/ConfirmOff.PNG" alt="Ventana de Confirmación de Desconexión"/>
		</P>

		<h2> Conectar una Nube </h2>
		<P>
			Si deseas conectar una nube primero debes verificar el estado de la misma en la barra superior del dashboard en la opción de Nube, allí podrás ver el nombre de la nube que estas gestionando y su estado actual. Para conectar una nube el icono que debe aparecer al lado del nombre de la nube es un enchufe de color rojo.
		</P>
		<P>
			<img src="/img/OnOffCloud/StateOff.PNG" alt="Estado Desconectado"/>
		</P>
		<P>
			Para conectar la nube solo tienes que hacer clic en el icono de configuración que se encuentra al lado del panel de selección de la nube.
		</P>
		<P>
			<img src="/img/OnOffCloud/StateOff_Focus.png" alt="Estado Desconectado Enfocado"/>
		</P>
		<P>
			Al hacer clic se te desplegara un menu donde encontraras la información de conexión de la nube y para conectarla solo debes dar clic sobre el switch y este cambiara su lugar y procederá a conectar la nube.
		</P>
		<P>
			<img src="/img/OnOffCloud/MenuOff_Focus.png" alt="Menu Desconectado"/>
		</P>
		<P>
			Como ultimo paso aparecerá una ventana de confirmación donde deberás dar clic en Aceptar si deseas conectar la nube o Cancelar si querés desistir de esta acción.
		</P>
		<P>
			<img src="/img/OnOffCloud/ConfirmOn.PNG" alt="Ventana de Confirmación de Conexión"/>
		</P>
	</Content>
	)
}
